type DatepickerFooterProps = { children: React.ReactNode };

export function DatepickerFooter({ children }: DatepickerFooterProps) {
    return (
        <div className="border-t border-icoGray-300 p-5 dark:border-icoDarkMode-beton">
            {children}
        </div>
    );
}
